// extracted by mini-css-extract-plugin
export default {"products":"hu-z","card":"iu-z","oosMessaging":"ju-z"};